import { Container, Divider, SkeletonText } from '@chakra-ui/react';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { useParams } from 'react-router-dom';
import CompanyHeader from '../components/CompanyHeader';
import CompanyRecipientsList from '../components/CompanyRecipientsList';
import CompaniesProvider from '../contexts/CompaniesContext';
import { useCompany } from '../hooks/useCompany';

export default function PageCompanyMembers() {
  const { id } = useParams();
  const { isFetched, data: company } = useCompany(id);

  const isLoaded = isFetched && !!company;

  return (
    <>
      <HeaderBarInternal
        title="Editar cliente"
        backTo="/clientes"
      >
        <CompanyHeader company={company} />
      </HeaderBarInternal>

      <Divider />

      <Container flexDirection="column">
        <SkeletonText isLoaded={isLoaded}>
        { company && (
          <CompaniesProvider companyId={company.id}>
            <CompanyRecipientsList company={company} />
          </CompaniesProvider>
        )}
        </SkeletonText>
      </Container>
    </>
  );
}
